import { render } from "./App.vue?vue&type=template&id=4be8b710"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4be8b710&lang=css"

import exportComponent from "/Volumes/development/experiments/kartograph/cartographer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__